import { cn, Icon, Skeleton, Typography } from "@kyan/ui";
import React from "react";

import { RequestStatusEnum } from "#/services/bridge/bridge.types";
import { copy } from "#/utils/copy";
import { formatAddress } from "#/utils/formatAddress";

import { BridgeStatus } from "./components/BridgeStatus/BridgeStatus";

interface BridgeIdProps {
  bridgeId: string;
  status?: RequestStatusEnum;
  className?: string;
}

export const BridgeId: React.FC<BridgeIdProps> = ({
  bridgeId,
  status,
  className,
}) => {
  return (
    <div
      className={cn(
        "border-divider text-textPrimary flex h-11 w-full items-center rounded-sm border",
        className,
      )}
    >
      <div className="border-divider flex h-full flex-1 items-center justify-between border-r px-3">
        <div className="flex flex-col gap-1">
          <Typography size={11} variant="secondary">
            Bridge ID
          </Typography>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`https://www.socketscan.io/tx/${bridgeId}`}
            className="hover:text-brandBlue text-xs transition-colors"
          >
            {formatAddress(bridgeId)}
          </a>
        </div>

        {status !== undefined ? <BridgeStatus status={status} /> : <Skeleton />}
      </div>
      <Icon
        name="copy"
        className="text-textSecondary hover:text-textPrimary mx-3 cursor-pointer transition-colors"
        onClick={() => {
          copy(bridgeId);
        }}
      />
    </div>
  );
};
